import { render, staticRenderFns } from "./108.vue?vue&type=template&id=bc009cac&scoped=true&"
var script = {}
import style0 from "./108.vue?vue&type=style&index=0&id=bc009cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc009cac",
  null
  
)

export default component.exports